module.exports = __webpack_public_path__ + "img/help.9f3e5796.svg";